import { Card } from "@postenbring/hedwig-react";
import { Track } from "../../shared/track/track";
import { CTAButtonGroup, LINKTYPE_CTA } from "./subcomponents/CTAButtonGroup";
import { ImageIllustration } from "./subcomponents/ImageIllustration";

import "./kp-cards.scss";
import { BodyLink } from "./subcomponents/BodyLink";
import { VideoOverlay } from "./subcomponents/VideoOverlay";

export const HeroCard = ({
    dataColorScheme,
    imageUrl,
    imageAltText,
    imagePosition,
    focalPointStyle,
    isIllustration,
    isAnimatedGif,
    pauseImageUrl,
    pauseAnimationLabel,
    playAnimationLabel,
    title,
    description,
    linkOrButtons,
    links,
    buttons,
    videoUrl,
    tracking,
    theme, //this is temporary used to support a background color in hero cards that rely on hds 4. Should be removed when hds 4 is no longer used.
}) => {
    const firstLinkOrButtonType = linkOrButtons?.[0]?.type;

    return (
        <Card
            variant="full-width"
            imagePosition={imagePosition}
            theme={theme}
            data-color-scheme={dataColorScheme}
        >
            {imageUrl && !videoUrl && (
                <ImageIllustration
                    imageUrl={imageUrl}
                    imageAltText={imageAltText}
                    isIllustration={isIllustration}
                    focalPointStyle={focalPointStyle}
                    isAnimatedGif={isAnimatedGif}
                    pauseImageUrl={pauseImageUrl}
                    pauseAnimationLabel={pauseAnimationLabel}
                    playAnimationLabel={playAnimationLabel}
                />
            )}
            {videoUrl && (
                <VideoOverlay
                    videoUrl={videoUrl}
                    imageUrl={imageUrl}
                    imageAltText={imageAltText}
                    isIllustration={isIllustration}
                    focalPointStyle={focalPointStyle}
                />
            )}

            <Card.Body>
                {title && (
                    <Card.BodyHeader>
                        <Card.BodyHeaderTitle as="h1" variant="h1">
                            {title}
                        </Card.BodyHeaderTitle>
                    </Card.BodyHeader>
                )}
                {description && <Card.BodyDescription>{description}</Card.BodyDescription>}
                {firstLinkOrButtonType === LINKTYPE_CTA ? (
                    <CTAButtonGroup buttons={linkOrButtons} inverted />
                ) : null}
                {links && links.map((link, index) => <BodyLink key={index} {...link} inverted />)}
                {buttons && <CTAButtonGroup buttons={buttons} inverted />}

                {tracking && <Track formLabelColor="white" {...tracking} />}
            </Card.Body>
        </Card>
    );
};
